import { useContext } from 'react';
import { useIntl } from 'react-intl';
import {
  DetailContext,
  abortableFetch,
  useEventCallback,
} from '@eas/common-web';
import {
  RedirectAction,
  useRedirect,
} from '@composite/redirect/dialog-redirect';
import { Agenda, EvidenceApiUrl, EvidenceBrowserUrl } from '@enums';

export function useNewInfDialog() {
  const intl = useIntl();

  const callApi = useEventCallback((id: string) =>
    abortableFetch(
      `${EvidenceApiUrl.DOCUMENTS}/${id}/submission?agenda=${Agenda.INF}`,
      {
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        method: 'PUT',
      }
    )
  );

  const { source } = useContext(DetailContext);

  // TODO
  const showButton = source.data?.id;

  const redirectBag = useRedirect({
    options: [
      {
        id: RedirectAction.REDIRECT_TO_RESULT,
        toResult: true,
        name: intl.formatMessage({
          id: 'REDIRECT__OPTION__NEW_INF_FILE',
          defaultMessage: 'Pokračovat v novém INF spisu',
        }),
      },
      {
        id: RedirectAction.STAY_IN_EVIDENCE,
        name: intl.formatMessage({
          id: 'REDIRECT__OPTION__UNPROCESSED_DOCUMENTS',
          defaultMessage: 'Pokračovat v nezpracovaných dokumentech',
        }),
      },
    ],
    redirectTo: EvidenceBrowserUrl.INF_FILES_NEW,
  });

  return {
    callApi,
    showButton,
    redirectBag,
  };
}
